module.exports = __webpack_public_path__ + "static/media/bond-dark.3cef227b.svg";